/* eslint-disable import/prefer-default-export */
import { agenticGet } from '../../utils/agenticApiClient';

// Route through agenticApiClient so the request carries the Bearer JWT
// (and the function code), same as every other agentic call. A bare fetch
// with only `?code=` 401s (AGENTIC_JWT_MISSING) because the FA gates every
// route on the BFF-minted JWT. agenticGet also dispatches 'api-activity'
// and surfaces a scoped toast on 401.
export const retrieveConversationMessages = async (threadId) =>
  agenticGet(`/api/threads/${threadId}/conversation`);
